module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('groupPages.modules.audios.title')))]), _c('audio'), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped audios"
  }, [_c('tbody', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable",
      value: ({
        onUpdate: _vm.onListReorder,
        handle: '.drag-handle'
      }),
      expression: "{onUpdate: onListReorder, handle: '.drag-handle'}"
    }]
  }, _vm._l((_vm.items), function(audio) {
    return _c('tr', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.playItem(audio)
        }
      }
    }, [_c('td', [(!_vm.player.playing || _vm.currentItem != audio) ? _c('i', {
      staticClass: "fa fa-play"
    }) : _c('i', {
      staticClass: "fa fa-pause"
    })]), _c('td', [_vm._v(_vm._s(audio.description))]), _c('td', [_vm._v(_vm._s(_vm._f("hrS")(audio.size)))]), _c('td', [_c('div', {
      staticClass: "duration"
    }, [(_vm.player.showDuration && _vm.player.playing && _vm.currentItem == audio) ? _c('span', [_vm._v(_vm._s(_vm._f("hrT")(_vm.player.currentSecond)) + " / " + _vm._s(_vm._f("hrT")(_vm.player.duration)))]) : _vm._e()])]), (_vm.openEditor) ? _c('td', [_vm._v("   "), _c('i', {
      staticClass: "text-danger fa fa-trash",
      on: {
        "click": function($event) {
          return _vm.remove(audio, $event)
        }
      }
    })]) : _vm._e()])
  }), 0)])]), (_vm.openEditor) ? _c('div', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.askUpload
    }
  }, [_c('div', {
    staticClass: "alert alert-info text-center"
  }, [_c('i', {
    staticClass: "fa fa-upload fa-2x"
  }), _c('br'), _vm._v(" " + _vm._s(_vm.$t('groupPages.modules.audios.import')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a652ebe","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupPages/GroupPageAudios.vue
// module id = 1260
// module chunks = 2